// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_eg-2";
export var aiChatCartContainerExit = "_eg-4";
export var aiChatContainerLarge = "_eg-0";
export var aiChatContainerSmall = "_eg-1";
export var aiChatIcon = "_eg-6";
export var slideInFromRight = "_eg-3";
export var slideOutToRight = "_eg-5";